import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity } from '../common/entity';

export enum CompanyRelationService {
  sap = 'sap',
  businessCentral = 'businessCentral',
  teamleader = 'teamleader',
  microsoft = 'microsoft',
}

export class IntegrationSettings extends CompanyEntity {
  name!: string;

  type: CompanyRelationService = CompanyRelationService.teamleader;

  settingsId!: string;
  externalId?: string;

  // SAP
  apiKey?: string;
  url?: string;
  plantId?: string;

  // Business Central
  tenantId?: string;
  environment?: string;
  clientId?: string;
  clientSecret?: string;

  userId?: string;
  externalCompanyId?: string;
  externalInfo?: string;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
  }
}
